<template>
  <div class="row">
    <div class="col-md-12 col-lg-6">

      <form class="position-relative"  data-vv-scope="form-profile" novalidate>
        <loader v-if="!loaded" class="table-loader"></loader>
        <div class="form-group row">
          <div class="col-md-12">

            <mdc-textfield id="username"
                           :label="'profile.username' | trans"
                           type="text"
                           name="username"
                           :class="{'is-invalid': errors.has('username') || errors.has('form-profile.username')}"
                           v-model="user.username"
                           v-validate="{required: true, max: 255, min: 5, regex: /^[a-zA-Z0-9._@-]+$/}"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.username' | trans"/>

            <span class="invalid-feedback"
                  v-if="errors.has('username') || errors.has('form-profile.username')">
                <strong>{{ errors.first('username') || errors.first('form-profile.username')}}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <mdc-textfield id="displayName"
                           :label="'profile.displayName' | trans"
                           type="text"
                           name="displayName"
                           :class="{'is-invalid': errors.has('displayName') || errors.has('form-profile.displayName')}"
                           v-validate="'required|max:255'"
                           v-model="user.displayName"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.displayName' | trans"/>

            <span class="invalid-feedback"
                  v-if="errors.has('displayName') || errors.has('form-profile.displayName')">
                <strong>{{ errors.first('displayName') || errors.first('form-profile.displayName') }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <mdc-textfield id="email"
                           v-model="user.email"
                           :label="'validation.attributes.email' | trans"
                           type="email" name="email"
                           :class="{'is-invalid': errors.has('email')  || responseHashError || errors.has('form-profile.email')}"
                           v-validate="'required|email|max:255'"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.email' | trans"/>
            <span class="invalid-feedback" v-if="errors.has('email') || errors.has('form-profile.email')">
                {{ errors.first('email') || errors.first('form-profile.email') }}
            </span>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12 text-right">
            <button type="submit" class="btn btn-primary"
                    @click.prevent="saveProfile()"
                    :disabled="disabled">
              {{'buttons.save' | trans}}
            </button>
          </div>
        </div>

      </form>

    </div>

    <div class="col-md-12 col-lg-6">

      <div class="form-group row" v-if="password_changed">
        <div class="col-md-12">
          <div class="alert alert-success">
            {{'reset_password.forms.reset_password.congrats.first_line' | trans}}
          </div>
        </div>
      </div>

      <form  data-vv-scope="form-pass" novalidate>

        <div class="form-group row">
          <div class="col-md-12">

            <mdc-textfield v-model="current_password"
                           :label="'validation.attributes.old_password' | trans"
                           type="password" name="current_password"
                           :class="{'is-invalid': errors.has('currentPassword') || errors.has('form-pass.current_password') }"
                           v-validate="'required|min:8|max:16'"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.old_password' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('currentPassword')  || errors.has('form-pass.current_password')">
                {{ errors.first('currentPassword') || errors.first('form-pass.current_password')}}
            </span>
          </div>
        </div>


        <div class="form-group row">
          <div class="col-md-12">

            <mdc-textfield v-model="password"
                           :label="'validation.attributes.new_password' | trans"
                           type="password" name="new_password"
                           :class="{'is-invalid': errors.has('new_password') || errors.has('form-pass.new_password')}"
                           v-validate="'required|min:8|max:16'"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.new_password' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('new_password') || errors.has('form-pass.new_password')">
               {{errors.first('new_password') || errors.first('currentPassword') || errors.first('form-pass.new_password') }}
            </span>
            <small class="form-text text-muted">
              {{'passwords.password_subscription' | trans}}
            </small>

          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <mdc-textfield v-model="password_confirmation"
                           :label="'validation.attributes.password_confirmation' | trans"
                           type="password" name="password_confirmation"
                           :class="{'is-invalid': errors.has('password_confirmation') || errors.has('newPasswordConfirmation') || errors.has('form-pass.password_confirmation')}"
                           v-validate="'required|min:8|max:16'"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.password_confirmation' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('password_confirmation') || errors.has('newPasswordConfirmation') || errors.has('form-pass.password_confirmation')">
                     {{ errors.first('password_confirmation')  || errors.first('newPasswordConfirmation') || errors.first('form-pass.password_confirmation')}}
            </span>

          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12 text-right">
            <button type="submit" class="btn btn-primary"
                    @click.prevent="savePassword()"
                    :disabled="disabled">
              {{'buttons.save' | trans}}
            </button>
          </div>
        </div>

      </form>

    </div>


  </div>
</template>

<script>
    import isObject from 'lodash/isObject';
    import Uploader from '../../fileUpload/components/Uploader';
    import Manager from '../api/Manager';
    import {Validator} from 'vee-validate';
    import Loader from '../../loader/components/Loader';
    import lang from '../../../lang/translator';

    export default {
    name: 'Profile',
    data() {
      return {
        user: {
          username: null,
          displayName: null,
          email: null
        },
        password: null,
        password_confirmation: null,
        current_password: null,
        disabled: false,
        afterSubmitForm:false,
        password_changed: false,
        responseHashError: null,
        baseUrl: process.env.APP_URL,
        loaded: true
      };
    },
    components: {Uploader, Loader},
    async created() {
      let response = await Manager.getAccountInfo();
      this.user = response.data.data;
    },
    methods: {
      async saveProfile() {
        let validateResult = await this.$validator.validateAll('form-profile');

        if (!validateResult) return;

        this.loaded = false;
        this.errors.clear();

        try {
          let isSaved = await Manager.setAccountInfo(this.user);

          if (isSaved){
            let result = await Manager.getAccountInfo();
            this.user = result.data.data;
            if (result){
              this.disabled = false;
              this.loaded = true;
              this.afterSubmitForm = true;
            }
          }

        } catch (response) {
          let errors = response.data.errors;
          if (isObject(errors)) {
            for (let key of Object.keys(errors)) {
              let {message} = errors[key].message ?
                  errors[key] :
                  errors[key][0];
              this.errors.add(key, message);
            }
          }
          this.loaded = true;
        }
      },
      async savePassword() {
        this.password_changed = false;
        this.errors.clear();

        let result = await this.$validator.validateAll('form-pass');

        if (!result) {
          this.disabled = false;
          return;
        }

        try {
          let isSaved = await Manager.changePassword(this.current_password,
              this.password,
              this.password_confirmation);

          if (isSaved){
            this.password_changed = true;
            this.password = null
            this.password_confirmation = null
            this.current_password = null
          }

        } catch (response) {
          let errors = response.data.errors;
          if (isObject(errors)) {
            for (let key of Object.keys(errors)) {
              let {message} = errors[key].message ?
                  errors[key] :
                  errors[key][0];
              this.errors.add(key, message);
            }
          }
        }

      },
    },

  };
</script>


// WEBPACK FOOTER //
// src/modules/profile/components/Profile.vue